import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Code2, Sparkles, Boxes } from 'lucide-react';
const services = [{
  icon: <PenTool size={32} className="text-[#7c5cfc]" data-id="element-117" />,
  title: 'עיצוב UX/UI',
  description: 'יצירת חוויות משתמש אינטואיטיביות וממשקים מרהיבים שמניעים לפעולה ומגדילים המרות.'
}, {
  icon: <Code2 size={32} className="text-[#22d3ee]" data-id="element-118" />,
  title: 'פיתוח Web',
  description: 'פיתוח אתרים ואפליקציות רשת מתקדמות, מהירות ומאובטחות בטכנולוגיות החדישות ביותר.'
}, {
  icon: <Sparkles size={32} className="text-[#ff2d8a]" data-id="element-119" />,
  title: 'מיתוג וגרפיקה',
  description: 'בניית שפה חזותית ייחודית, לוגואים וזהות מותגית שבולטת מעל המתחרים.'
}, {
  icon: <Boxes size={32} className="text-[#f59e0b]" data-id="element-120" />,
  title: 'אנימציה ותלת-מימד',
  description: 'הנפשות מורכבות, מיקרו-אינטראקציות ואלמנטים בתלת-מימד שמעוררים את האתר לחיים.'
}];
export function Services() {
  return <section id="services" className="py-32 relative z-20 bg-[#0a0a0f]" data-id="element-121">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-122">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-123">
          <h2 className="text-5xl md:text-7xl font-display font-black text-white mb-6" data-id="element-124">
            מה אנחנו <span className="text-gradient" data-id="element-125">עושים</span>
          </h2>
          <p className="text-xl text-white/60 max-w-2xl mx-auto" data-id="element-126">
            מעטפת מלאה של שירותים דיגיטליים, משלב הרעיון ועד למוצר המוגמר.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-127">
          {services.map((service, index) => <motion.div key={index} className="p-10 rounded-3xl bg-white/[0.02] border border-white/5 hover:bg-white/[0.04] hover:border-white/10 transition-colors duration-300 relative group overflow-hidden" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} data-id="element-128">
              <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-129" />
              <div className="relative z-10" data-id="element-130">
                <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500" data-id="element-131">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-display font-bold text-white mb-4" data-id="element-132">
                  {service.title}
                </h3>
                <p className="text-white/60 leading-relaxed" data-id="element-133">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}